import { Directive, Input, ContentChild, OnInit } from '@angular/core';
import { DataTableRow } from './row.component';
import { CellCallback } from './types';



export class DataTableColumn implements OnInit {

    // init:
     header: string;
     sortable = false;
     resizable = false;
     property: string;
     styleClass: string;
     cellColors: CellCallback;

    // init and state:
     width: number | string;
     visible = true;

     cellTemplate;
     headerTemplate;

    getCellColor(row: DataTableRow, index: number) {
        if (this.cellColors !== undefined) {
            return (<CellCallback>this.cellColors)(row.item, row, this, index);
        }
    }

    private styleClassObject = {}; // for [ngClass]

    ngOnInit() {
        this._initCellClass();
    }

    private _initCellClass() {
        if (!this.styleClass && this.property) {
            if (/^[a-zA-Z0-9_]+$/.test(this.property)) {
                this.styleClass = 'column-' + this.property;
            } else {
                this.styleClass = 'column-' + this.property.replace(/[^a-zA-Z0-9_]/g, '');
            }
        }

        if (this.styleClass != null) {
            this.styleClassObject = {
                [this.styleClass]: true
            };
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'data-table-column'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'header': [{ type: Input },],
'sortable': [{ type: Input },],
'resizable': [{ type: Input },],
'property': [{ type: Input },],
'styleClass': [{ type: Input },],
'cellColors': [{ type: Input },],
'width': [{ type: Input },],
'visible': [{ type: Input },],
'cellTemplate': [{ type: ContentChild, args: ['dataTableCell', ] },],
'headerTemplate': [{ type: ContentChild, args: ['dataTableHeader', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
